export const FastSearchMutations = {}
